export const billsandPaymentsHistoryConstants={
    BILLS_AND_PAYMENTS_HISTORY_DATA_SUCCESS:"BILLS_AND_PAYMENTS_HISTORY_DATA_SUCCESS",
    BILLS_AND_PAYMENTS_HISTORY_TAB_SUCCESS:"BILLS_AND_PAYMENTS_HISTORY_TAB_SUCCESS",
  }